window.Tether = require("tether");
//require("bootstrap-4");
require("../../less/landing/landing.less");



// WEBPACK FOOTER //
// client/pages/landing/landing.js